module.exports = __webpack_public_path__ + "media/images/cert-background-7-893c505c2f3e66fec52b43d164e6b44b.jpg";